export enum TipoServicio {
    Indeterminado= 0,
    Alije= 1,
    Rancho= 2,
    AlijeVariable= 3
}
